import Image from "../../assets/Image";


 const PortfolioImages = [
    {
      id: 1,
      image:Image.innerPortfolio1,
      author: "Do It Center",

    },
    {
      id: 2,
      image:
        "https://harnishdesign.net/demo/react/callum/demo/images/projects/project-2.jpg",
        author: "Do It Center",
    },
    {
      id: 3,
      image:
        "https://harnishdesign.net/demo/react/callum/demo/images/projects/project-1.jpg",
    },
    {
      id: 4,
      image:
        "https://harnishdesign.net/demo/react/callum/demo/images/projects/project-4.jpg",
    },
    {
      id: 5,
      image:
        "https://harnishdesign.net/demo/react/callum/demo/images/projects/project-3.jpg",
    },
    {
      id: 6,
      image:
        "https://harnishdesign.net/demo/react/callum/demo/images/projects/project-6.jpg",
    },
  ];


export default PortfolioImages;
